var fileStore = {},
    addFile = function addFile(a) {
  fileStore[a] = !0;
},
    getFile = function getFile(a) {
  return fileStore[a];
};

export { addFile, getFile };
export default {
  extension: function extension(a) {
    a.addFile = addFile, a.getFile = getFile;
  },
  name: 'fileStore',
  type: 'plugin',
  requiresFusionCharts: !0
};